import { AutogenModelStates, AutogenRowStates } from "./autogen/AutogenModelStates";

export class ModelStates extends AutogenModelStates<RowStates> {
	constructor() {
		super(RowStates);
	}
}

export class RowStates extends AutogenRowStates {
}